import { render, staticRenderFns } from "./StarBirthdayDetails.vue?vue&type=template&id=fdf8664a&scoped=true&"
import script from "./StarBirthdayDetails.vue?vue&type=script&lang=js&"
export * from "./StarBirthdayDetails.vue?vue&type=script&lang=js&"
import style0 from "./StarBirthdayDetails.vue?vue&type=style&index=0&id=fdf8664a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf8664a",
  null
  
)

export default component.exports